export default __webpack_public_path__ + "static/media/1.1e4314d7.png";